/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _CustomInputs */

const en__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Custom`)
};

const es__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Personalizado`)
};

const fr__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Personnalisé`)
};

const de__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Benutzerdefiniert`)
};

const ja__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ カスタム`)
};

const zh__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 自定义`)
};

const ar__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ مخصص`)
};

const id__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Kustom`)
};

const it__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Personalizzato`)
};

const ru__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Пользовательский`)
};

const pt__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Personalizado`)
};

const ko__custom = /** @type {(inputs: _CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 맞춤 설정`)
};

/**
* | output |
* | --- |
* | "+ Custom" |
*
* @param {_CustomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const _custom = /** @type {((inputs?: _CustomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_CustomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__custom(inputs)
	if (locale === "es") return es__custom(inputs)
	if (locale === "fr") return fr__custom(inputs)
	if (locale === "de") return de__custom(inputs)
	if (locale === "ja") return ja__custom(inputs)
	if (locale === "zh") return zh__custom(inputs)
	if (locale === "ar") return ar__custom(inputs)
	if (locale === "id") return id__custom(inputs)
	if (locale === "it") return it__custom(inputs)
	if (locale === "ru") return ru__custom(inputs)
	if (locale === "pt") return pt__custom(inputs)
	return ko__custom(inputs)
});